import { CoreIcon } from '../core-icon';
import searchSVG from '../../assets/icons/search.svg';
import type { IconProps } from '../core-icon';

export const SearchIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={searchSVG} {...props} />;
};
